var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useRef, useState } from "react";
import Table from "@components/Table/Table";
import { Loading } from "@components/Loading/Loading";
import { Icon, hasValue } from "uxp/components";
import { executeQuery } from "@query-engine-service";
import './PreviewTable.scss';
/**
 * Presentational table renderer shared between the QueryEditor preview pane
 * and the standalone PreviewTable / QueryPreview components.
 *
 * Derives columns from the first row of `data` (identical logic to the one
 * previously inlined in QueryEditor.renderPreview) and renders the shared
 * resizable Table.
 */
export const PreviewTableView = ({ data }) => {
    const columns = data && data.length > 0 ? Object.keys(data[0]).map(key => ({
        id: key,
        label: key
    })).filter(a => hasValue(a.id)) : [];
    return React.createElement(Table, { columns: columns, data: data || [] });
};
/**
 * Self-contained preview table. Executes the given query in preview mode on
 * mount and whenever the query changes, and renders loading / error / empty /
 * table states.
 */
export const PreviewTable = ({ query, uxpContext }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const cancelledRef = useRef(false);
    const $L = (key) => uxpContext.$L(key);
    useEffect(() => {
        cancelledRef.current = false;
        function run() {
            return __awaiter(this, void 0, void 0, function* () {
                setLoading(true);
                setError(null);
                const { data, error } = yield executeQuery({
                    uxpContext
                }, query, {
                    mode: 'preview'
                });
                if (cancelledRef.current)
                    return;
                setError(error || null);
                setData((data === null || data === void 0 ? void 0 : data.result) || []);
                setLoading(false);
            });
        }
        if (query)
            run();
        else
            setLoading(false);
        return () => {
            cancelledRef.current = true;
        };
    }, [JSON.stringify(query)]);
    if (loading)
        return React.createElement(Loading, null);
    if (!!error) {
        return React.createElement("div", { className: "lqe-pt__error-482c1cdb" },
            React.createElement(Icon, { icon: ['fas', 'exclamation-triangle'], className: "lqe-pt__error-ico-482c1cdb" }),
            React.createElement("div", { className: "lqe-pt__error-title-482c1cdb" }, $L('lqe.qe.preview-error-title')),
            React.createElement("div", { className: "lqe-pt__error-msg-482c1cdb" }, error));
    }
    if (!data || data.length === 0) {
        return React.createElement("div", { className: "lqe-pt__empty-482c1cdb" }, $L('lqe.qp.no-data'));
    }
    return React.createElement("div", { className: "lqe-pt-482c1cdb" },
        React.createElement(PreviewTableView, { data: data }));
};
export default PreviewTable;
